import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=35f5afa5&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=35f5afa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5afa5",
  null
  
)

export default component.exports